const FetchAi = ({...props}) => {
  return (
    <svg
      width="290"
      height="49"
      viewBox="0 0 290 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M289.795 13.7677H283.59V47.5151H289.795V13.7677Z"
        fill="#CFB2FF"
      />
      <path
        d="M219.397 47.4838V28.5259C219.397 23.1536 215.384 19.078 210.042 19.078C205.504 19.078 200.872 22.5669 200.872 29.2052V47.5148H194.666V1.97265L200.872 1.94177C200.872 1.94177 200.841 16.577 200.872 16.5461C201.706 15.836 204.917 12.9954 211.308 12.9954C219.089 12.9954 225.635 19.4793 225.635 27.1674V47.4838H219.397Z"
        fill="#CFB2FF"
      />
      <path
        d="M289.795 1.97266H283.59V8.17873H289.795V1.97266Z"
        fill="#CFB2FF"
      />
      <path
        d="M238.141 41.2467H231.904V47.4837H238.141V41.2467Z"
        fill="#CFB2FF"
      />
      <path
        d="M46.864 22.2577C47.2962 22.8752 47.5125 23.6162 47.5125 24.3881C47.5125 25.4071 47.111 26.3642 46.401 27.0743C45.6909 27.7846 44.7028 28.1858 43.7147 28.1858C42.9736 28.1858 42.2327 27.9698 41.5843 27.5376C40.9668 27.1053 40.4728 26.5187 40.1949 25.8394C39.9169 25.1291 39.8243 24.3881 39.9787 23.6471C40.1331 22.9061 40.5035 22.2268 41.0286 21.7019C41.5535 21.177 42.2327 20.8065 42.9738 20.6521C43.7147 20.4977 44.4865 20.5904 45.1658 20.8683C45.8451 21.1153 46.4317 21.6093 46.864 22.2577Z"
        fill="#CFB2FF"
      />
      <path
        d="M46.864 41.523C47.2962 42.1404 47.5125 42.8815 47.5125 43.6534C47.5125 44.6723 47.111 45.6296 46.401 46.3397C45.6909 47.0497 44.7028 47.4512 43.7147 47.4512C42.9736 47.4512 42.2327 47.2352 41.5843 46.8027C40.9668 46.3705 40.4728 45.7838 40.1949 45.1045C39.9169 44.3945 39.8243 43.6534 39.9787 42.9125C40.1331 42.1715 40.5035 41.4922 41.0286 40.9673C41.5535 40.4423 42.2327 40.0718 42.9738 39.9174C43.7147 39.763 44.4865 39.8556 45.1658 40.1337C45.8451 40.4115 46.4317 40.9055 46.864 41.523Z"
        fill="#CFB2FF"
      />
      <path
        d="M47.5102 0.736694H38.3711V9.87599H47.5102V0.736694Z"
        fill="#CFB2FF"
      />
      <path
        d="M27.8473 41.523C28.2796 42.1404 28.4958 42.8815 28.4958 43.6534C28.4958 44.6723 28.0944 45.6296 27.3843 46.3397C26.674 47.0497 25.6861 47.4512 24.698 47.4512C23.957 47.4512 23.216 47.2352 22.5676 46.8027C21.9501 46.3705 21.4561 45.7838 21.1782 45.1045C20.9003 44.3945 20.8077 43.6534 20.9621 42.9125C21.1164 42.1715 21.487 41.4922 22.0118 40.9673C22.5367 40.4423 23.216 40.0718 23.957 39.9174C24.698 39.763 25.4699 39.8556 26.1492 40.1337C26.8595 40.4115 27.4459 40.9055 27.8473 41.523Z"
        fill="#CFB2FF"
      />
      <path
        d="M29.2643 19.7864H20.125V28.9256H29.2643V19.7864Z"
        fill="#CFB2FF"
      />
      <path
        d="M29.5119 0.736694H19.8477V10.4009H29.5119V0.736694Z"
        fill="#CFB2FF"
      />
      <path
        d="M10.9892 0.736694H0.831055V10.8949H10.9892V0.736694Z"
        fill="#CFB2FF"
      />
      <path
        d="M9.93518 38.3116H0.795898V47.4507H9.93518V38.3116Z"
        fill="#CFB2FF"
      />
      <path
        d="M10.4601 19.5411H0.795898V29.2054H10.4601V19.5411Z"
        fill="#CFB2FF"
      />
      <path
        d="M85.9219 6.26346C88.639 6.29432 89.7505 8.30126 89.7505 8.30126L93.6409 4.38C91.356 1.90993 88.5774 0.551392 85.7367 0.551392C82.9578 0.551392 80.673 1.4468 78.944 3.17584C77.184 4.93578 76.3195 7.18973 76.3195 9.90683V13.7663H71.0088V19.1079H76.2887V47.5138H82.4948V19.1079H86.7248H93.6409V13.7663H84.2548H82.5256V9.90683C82.5256 7.68374 83.7297 6.41783 85.9219 6.26346Z"
        fill="#CFB2FF"
      />
      <path
        d="M176.545 42.1438C169.845 42.1438 164.966 37.2963 164.966 30.658C164.966 24.1122 169.968 19.1411 176.637 19.1411C180.312 19.1411 183.214 21.2716 184.449 22.3523L188.679 18.1222C187.475 16.9489 182.936 12.9968 176.329 12.9968C166.386 12.9968 158.637 20.7467 158.637 30.627C158.637 40.4764 166.418 48.1953 176.36 48.1953C182.689 48.1953 186.981 44.7374 188.679 43.0393L184.542 38.9637C183.029 40.3838 180.342 42.1438 176.545 42.1438Z"
        fill="#CFB2FF"
      />
      <path
        d="M148.045 42.5117C145.976 42.5117 144.401 41.1222 144.401 37.0774V19.1076H155.517V13.7661H144.401V6.88074H138.195V37.0774C138.195 44.7037 141.715 48.1619 147.952 48.1619C150.268 48.1619 153.139 47.2356 155.64 45.167L151.719 41.2458C150.762 42.0793 149.434 42.5117 148.045 42.5117Z"
        fill="#CFB2FF"
      />
      <path
        d="M114.451 42.0196C108.43 42.0196 104.077 37.6044 103.212 33.0347H128.191H131.803C131.896 32.2628 131.958 31.4602 131.958 30.6573C131.958 20.9313 124.053 13.0271 114.327 13.0271C104.602 13.0271 96.6973 20.9313 96.6973 30.6573C96.6973 40.3832 104.602 48.2874 114.327 48.2874C120.163 48.2874 125.011 46.1878 128.314 42.9459L124.455 38.5925C121.769 40.9081 118.403 42.0196 114.451 42.0196ZM114.451 19.1097C120.07 19.1097 124.177 23 125.35 27.6932H103.305C104.571 22.7839 108.77 19.1097 114.451 19.1097Z"
        fill="#CFB2FF"
      />
      <path
        d="M269.726 13.7687V17.4121C269.726 17.4121 265.651 12.9968 258.517 12.9968C248.822 12.9968 240.92 20.8085 240.92 30.411C240.92 40.3838 248.515 48.1953 258.241 48.1953C266.329 48.1953 269.726 43.7493 269.726 43.7493V47.4545H275.931V13.7687H269.726ZM259.074 42.1438C258.89 42.1438 258.673 42.1745 258.455 42.1745C255.276 42.1745 252.405 40.8778 250.305 38.7782C248.207 36.6788 246.908 33.8073 246.908 30.5962C246.908 24.2048 252.097 19.0485 258.517 19.0485C264.94 19.0485 270.127 24.2048 270.127 30.5962C270.127 36.8022 265.219 41.8349 259.074 42.1438Z"
        fill="#CFB2FF"
      />
    </svg>
  );
};

export default FetchAi;
